import { avatarColorForSeed } from "@/lib/avatarColors";

/** Règle UNIQUE (= Paramètres › Utilisateurs / backend services/user_identity.py) : 1re lettre du prénom + 1re lettre du nom. Un `initials` fourni par le serveur prime toujours. */
export const initialsOf = (u) => {
  if (u?.initials) return u.initials;
  if (typeof u === "string") { const p = u.trim().split(/\s+/).filter(Boolean); return p.length > 1 ? `${p[0][0]}${p[p.length - 1][0]}`.toUpperCase() : (p[0] || "?")[0].toUpperCase(); }
  return `${(u?.first_name || "")[0] || ""}${(u?.last_name || "")[0] || ""}`.toUpperCase() || (u?.email || "?")[0].toUpperCase();
};

/** iter435 pt 2 / iter436 pt 2 — pastille d'initiales d'un UTILISATEUR : initiales + couleur du serveur (source unique), sinon même règle locale ; jamais grise. */
export default function UserInitials({ user, name, seed, size = 26, fontSize, ring = "#17171B", ringWidth = 2, style, className = "", testId }) {
  const label = user ? `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.name || name || "" : name || "";
  const bg = user?.avatar_color || avatarColorForSeed(seed || user?.id || user?.email || label).bg;
  return (
    <span className={`inline-flex items-center justify-center shrink-0 select-none ${className}`} title={label} data-testid={testId} data-user-initials=""
      style={{ width: size, height: size, borderRadius: "50%", background: bg, color: "#FFFFFF", fontSize: fontSize ?? Math.round(size * 0.365 * 10) / 10, fontWeight: 600, lineHeight: 1, border: ringWidth ? `${ringWidth}px solid ${ring}` : "none", boxSizing: "border-box", ...style }}>
      {initialsOf(user || label)}
    </span>
  );
}
